export const GLOBAL_IMPRESSION_FIRED_COUNTER = 'impressionFired';

export type IMPRESSION_COUNTERS = typeof GLOBAL_IMPRESSION_FIRED_COUNTER;
